"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listingFeePercent = listingFeePercent;
exports.calculateListingFee = calculateListingFee;
exports.itemListError = itemListError;
const interfaces_1 = require("@lotr/interfaces");
function listingFeePercent() {
    return 0.05;
}
function calculateListingFee(item, sellPrice) {
    return Math.max(1, Math.floor((sellPrice + (item.sellValue || item.value)) * listingFeePercent()));
}
function itemListError(player, item, realItem, price) {
    if (!player)
        return '';
    if ([interfaces_1.ItemClass.Corpse, interfaces_1.ItemClass.Coin].includes(realItem.itemClass)) {
        return 'That cannot be sold on the market.';
    }
    if (item.mods.owner)
        return 'That item is bound and cannot be sold.';
    if (item.mods.encrustItem) {
        return 'That item is encrusted and cannot be sold.';
    }
    if (item.mods.destroyOnDrop || realItem.destroyOnDrop) {
        return 'That item is too fragile to be sold.';
    }
    if (item.mods.useEffect)
        return 'That item is too unique to sell.';
    const gold = player.currency[interfaces_1.Currency.Gold] ?? 0;
    if (gold < calculateListingFee(realItem, price)) {
        return 'You do not have enough money to list that item.';
    }
    return '';
}
